import hoistNonReactStatics from 'hoist-non-react-statics';

// hoistNonReactStatics as HOF
export default Component => HigherOrderComponent =>
  hoistNonReactStatics(HigherOrderComponent, Component);
